<template>
  <v-col
    cols="12"
  >
    <v-card>
      <v-card-title>
        Create event
      </v-card-title>

      <v-form
        @submit="createEvent"
      >
        <v-container>
          <v-row>
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="name"
                label="Event Name"
                required
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select
                v-model="admin"
                :items="committee"
                item-text="name"
                item-value="email"
                label="Admin"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="6"
            >
              <v-text-field
                v-model="begins"
                label="Begins"
                type="date"
                required
              />
            </v-col>
            <v-col
              cols="6"
            >
              <v-text-field
                v-model="ends"
                label="Ends"
                type="date"
                required
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="2"
            >
              <v-btn
                type="submit"
              >
                Create Event
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: 'CreateEvent',
  props: {
    client: {
      type: Object,
      required: true,
    },
    committee: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      name: '',
      begins: undefined,
      ends: undefined,
      admin: undefined,
    };
  },
  methods: {
    async createEvent(form) {
      form.preventDefault();
      const response = await this.client.createEvent(this.name, this.admin, this.begins, this.ends);
      const url = new URL(response);
      // returned as e.g. /api/v1/events/478ad5f2-3898-4fc7-8f89-f0585c0982ea
      const eventId = url.pathname.split('/').pop();
      this.$router.push({ name: 'Event', params: { eventId } });
    },
  },
};
</script>
